module.exports = __webpack_public_path__ + "img/cardBack.24d5d660.png";